module.exports = __webpack_public_path__ + "media/images/countrysquared/iq-6015c69f94784653d7fd7d9e97c9e6e2.svg";